import { createTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

export const theme = createTheme({
    palette: {
        type: 'light', 
        primary: {
            main:'#009245'
        }, 
        secondary: {
            main:'#f50057'
        },
        error: red,
    },
});
